<div
  *ngIf="!productDetails"
  class="w-100 h-100 d-flex justify-content-center align-items-center mt-5"
>
  <span style="margin-right: 5px">Carregando</span>
  <mat-spinner [diameter]="30"></mat-spinner>
</div>
<div *ngIf="productDetails">
  <div
    class="box-carousel-banner"
    [ngClass]="{ 'cursor-inherit': allImages && allImages.length == 1 }"
  >
    <div class="button-zoom-banner">
      <button
        mat-raised-button
        (click)="openDialogBanners()"
        style="outline: none; border: 0; background-color: #f7f7f7; padding: 0"
      >
        <img
          loading="lazy"
          class="img-100"
          style="z-index: 1000"
          src="/assets/icons/zoom-icon-gray.png"
          alt=""
        />
      </button>
    </div>
    <div
      id="carouselBanners"
      (mousedown)="calcStart($event)"
      (mouseup)="calcEnd($event)"
      (touchstart)="calcStart($event)"
      (touchend)="calcEnd($event)"
      class="carousel slide mt-5"
    >
      <div
        class="carousel-indicators selector-list"
        *ngIf="allImages && allImages.length > 1"
      >
        <button
          type="button"
          data-bs-target="#carouselBanners"
          *ngFor="let image of allImages; let i = index"
          [attr.data-bs-slide-to]="i"
          [class]="i == 0 ? 'active' : ''"
          [attr.aria-current]="i == 0"
          aria-label="Slide 1"
        ></button>
      </div>
      <div class="carousel-inner">
        <div
          (dragstart)="onDragStart($event)"
          class="carousel-item h-100"
          [ngClass]="{ active: i === 0 }"
          *ngFor="let image of allImages; let i = index"
        >
          <app-crop-images
            class="d-block m-auto text-center crop h-100"
            index="{{ i }}"
            imageCarrosel="{{ image }}"
          ></app-crop-images>
        </div>
      </div>
    </div>
  </div>
  <div style="background-color: #f1f1f1">
    <div
      class="d-lg-flex"
      style="background-color: #f1f1f1; position: relative"
    >
      <div class="container p-2 pb-4 p-md-3 pb-md-4 pt-md-4 p-lg-4 p-xl-5">
        <div *ngIf="breadcrumb" class="footer-gray-light">
          <a href="/linhas"> Linha de Produtos </a>
          <span class="arrow-bread-crumb" *ngIf="breadcrumb.category">
            >>
          </span>
          <a *ngIf="breadcrumb.category" href="{{ breadcrumb.category.link }}">
            {{ breadcrumb.category.name }}</a
          >
          <span class="arrow-bread-crumb" *ngIf="breadcrumb.subcategory">
            >>
          </span>
          <a
            *ngIf="breadcrumb.subcategory"
            href="{{ breadcrumb.subcategory.link }}"
          >
            {{ breadcrumb.subcategory.name }}</a
          >
          <span class="arrow-bread-crumb" *ngIf="breadcrumb.subsubcategory">
            >>
          </span>
          <a
            *ngIf="breadcrumb.subsubcategory"
            href="{{ breadcrumb.subsubcategory.link }}"
          >
            {{ breadcrumb.subsubcategory.name }}</a
          >
        </div>

        <div class="title pt-3 pb-3" style="line-height: 1">
          <span style="text-transform: none">
            <p class="m-0">
              {{
                productDetails.nome
                  ? productDetails.nome
                  : productDetails.desPro
              }}
              <span
                *ngIf="productDetails.fora_de_linha"
                style="
                  color: var(--font-subtitle-gray) !important;
                  text-transform: uppercase;
                "
                >- Indisponível</span
              >
            </p>
          </span>
        </div>
        <span class="codPro"> Referência: {{ productDetails.codPro }} </span>
        <div class="description mt-3 mt-3">
          {{ productDetails.descricao ? productDetails.descricao : "" }}
        </div>
      </div>
      <div
        *ngIf="productDetails.DOCTEC && verificarPrefixo(productDetails.DOCTEC)"
        class="d-flex justify-content-center d-lg-block p-lg-5"
      >
        <button
          class="btn-detalhamento"
          (click)="downloadFile(productDetails.DOCTEC)"
        >
          Detalhamento técnico
        </button>
      </div>
    </div>
  </div>
  <div class="container mb-4" *ngIf="this.listReferences && this.listReferences?.length > 0">
    <div
      class="pt-5"
      style="width: fit-content"
    >
      <p class="title-detail-products">Referências</p>
      <hr class="border-titles" width="100%" />
    </div>
    <div
      class="area-table-variantes"
      *ngIf="this.listReferences && this.listReferences.length > 0"
    >
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="codPro">
          <th mat-header-cell *matHeaderCellDef>Ref.</th>
          <td mat-cell *matCellDef="let element">
            <a
              class="text-decoration-none"
              routerLink="/produto-detalhe/{{ element.slug ? element.slug : element.codPro }}"
              >{{ element.codPro }}</a
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="desPro">
          <th mat-header-cell *matHeaderCellDef>Nome</th>
          <td mat-cell *matCellDef="let element">{{ element.desPro }}</td>
        </ng-container>

        <ng-container
          *ngFor="let atributo of attributesExpanded; let i = index"
          [matColumnDef]="atributo.nome"
        >
          <th mat-header-cell *matHeaderCellDef>{{ atributo.nome }}</th>
          <td mat-cell *matCellDef="let element">
            {{
              getAttributeValue(
                atributo.atributoId,
                element.codPro,
                element.codEmp
              )
            }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
  <div class="container d-flex gap-5">
    <div class="row">
      <!-- CARACTERÍSTICAS -->
      <div class="col-12 col-md-6 mb-4" *ngIf="filteredCharacteristics?.length > 0">
        <div
          class="pt-5"
          style="width: fit-content"
        >
          <p class="title-detail-products">CARACTERÍSTICAS</p>
          <hr class="border-titles" width="100%" />
        </div>
        <div
          *ngIf="filteredCharacteristics?.length > 0"
          class="product-feature"
        >
          <div
            class="d-flex mb-2 mt-2"
            *ngFor="let characteristic of filteredCharacteristics"
          >
            <img src="{{ characteristic.icone }}" alt="" loading="lazy" />
            <div>
              <div class="title-product-feature">
                {{ characteristic.titulo }}
              </div>
              <div class="desciption-product-feature">
                {{ characteristic.descricao }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 mb-4" *ngIf="filteredQualityTests?.length > 0">
        <div
          class="pt-5"
          style="width: fit-content"
        >
          <p class="title-detail-products">TESTES DE QUALIDADE</p>
          <hr class="border-titles" width="100%" />
        </div>
        <div *ngFor="let qualityTest of filteredQualityTests">
          <p class="title-product-feature">
            {{ qualityTest.titulo }} <br />
            <span class="desciption-product-feature">
              {{ qualityTest.subtitulo }}
            </span>
          </p>

          <p class="desciption-product-feature">
            {{ qualityTest.descricao }}
          </p>
        </div>
      </div>
      <!-- APLICAÇÃO -->
      <div class="col-12 col-md-6" *ngIf="productDetails.url_aplicacao">
        <div
          class="pt-5"
          style="width: fit-content"
        >
          <p class="title-detail-products">APLICAÇÃO</p>
          <hr class="border-titles" width="100%" />
        </div>
        <div
          *ngIf="productDetails.url_aplicacao"
          style="max-width: 100%; height: auto; position: relative"
        >
          <div style="position: absolute; top: 10px; right: 1em">
            <button
              mat-raised-button
              (click)="openDialog(productDetails.url_aplicacao)"
              style="z-index: 1; border: 0; background-color: transparent"
            >
              <img
                loading="lazy"
                class="img-100"
                style="z-index: 1"
                src="/assets/icons/zoom_icon.png"
                alt=""
              />
            </button>
          </div>
          <img
            loading="lazy"
            class="img-100"
            style="width: 100%; height: 100%; object-fit: contain"
            src="{{ productDetails.url_aplicacao }}"
            alt="url aplicação"
          />
        </div>
        <div class="text-center p-2" style="font-size: 12px; color: #7e7e7e">
          <p *ngIf="productDetails.url_aplicacao">
            Exemplo de aplicação do produto.
          </p>
        </div>
        <!-- FUNCIONAMENTO -->
      </div>
      <div class="col-12 col-md-6" *ngIf="productDetails.url_funcionamento">
        <div
          class="pt-5"
          style="width: fit-content"
        >
          <p class="title-detail-products">FUNCIONAMENTO</p>
          <hr class="border-titles" width="100%" />
        </div>
        <div
          *ngIf="productDetails.url_funcionamento"
          style="max-width: 100%; height: auto; position: relative"
        >
          <div style="position: absolute; top: 10px; right: 1em">
            <button
              mat-raised-button
              (click)="openDialog(productDetails.url_funcionamento)"
              style="z-index: 1; border: 0; background-color: transparent"
            >
              <img
                loading="lazy"
                class="img-100"
                style="z-index: 1"
                src="/assets/icons/zoom_icon.png"
                alt=""
              />
            </button>
          </div>
          <img
            loading="lazy"
            class="img-100"
            style="width: 100%; height: 100%; object-fit: contain"
            src="{{ productDetails.url_funcionamento }}"
            alt="url funcionamento"
          />
        </div>
        <div
          *ngIf="productDetails.url_funcionamento"
          class="text-center p-2"
          style="font-size: 12px; color: #7e7e7e"
        >
          <p>Exemplo de funcionamento do fecho.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container mb-5" *ngIf="productDetails.VIDPR1 || productDetails.VIDPR2">
    <div class="row">
      <div
        class="pt-2"
        style="width: fit-content"
      >
        <p class="title-detail-products">VÍDEOS</p>
        <hr class="border-titles" width="100%" />
      </div>
        <div class="d-flex row">
          <div *ngIf="productDetails.VIDPR1" class="col-md-6 mb-4">
            <div class="video-container">
              <iframe
                [src]="getVideoIframeUrl(productDetails.VIDPR1) | safe"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div *ngIf="productDetails.VIDPR2" class=" col-md-6 mb-4">
            <div class="video-container">
              <iframe
                [src]="getVideoIframeUrl(productDetails.VIDPR2) | safe"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
        </div>
      </div>
    </div>
  </div>

  <div style="background-color: #e6eaf3; padding-bottom: 50px">
    <div class="container pt-5 pb-5 d-flex justify-content-center">
      <div style="width: fit-content" class="title">
        <span>Veja também</span>
        <hr class="border-titles" width="100%" />
      </div>
    </div>
    <div class="box-carousel" style="position: relative">
      <div class="box-slide">
        <div class="area-slide" id="images">
          <a
            *ngFor="let variant of carouselItems"
            class="a-card"
            style="text-decoration: none"
            href="/produto-detalhe/{{ variant.slug ? variant.slug : variant.codPro }}"
          >
            <div class="card-slide">
              <div
                *ngIf="!variant.resizedImageUrl"
                class="img-prod-slide loader-card-prod"
              ></div>
              <img
                class="img-prod-slide"
                *ngIf="variant.resizedImageUrl"
                src="{{ variant.resizedImageUrl }}"
                alt="imagem de produto similar"
                loading="lazy"
              />
              <p class="title-products-cards text-uppercase">
                {{
                  variant.desPro
                    ? variant.desPro
                    : variant.nome
                    ? variant.nome
                    : "Sem nome"
                }}
              </p>
              <p class="card-codPro">Ref: {{ variant.codPro }}</p>
            </div>
          </a>
        </div>
      </div>

      <button class="btn" [disabled]="clicked" (click)="buttonLeftClicked()">
        <img
          loading="lazy"
          class="img-100"
          src="/assets/icons/arrow_left.svg"
          alt="seta a esquerda"
        />
      </button>
      <button
        class="btn right"
        [disabled]="clicked"
        (click)="buttonRightClicked()"
      >
        <img
          loading="lazy"
          class="img-100"
          src="/assets/icons/arrow_right.svg"
          alt="seta a direita"
        />
      </button>
    </div>
  </div>
</div>
